import React from "react";
import { Link } from "react-router-dom";
import ContentPage from "../../components/layout/contentPage";
import { VImage } from "../../style/base.style";
import { useParams } from "react-router-dom";
import { articles } from "../../assets/constant/articles";
import { useDictionary } from "../../contexts/dictionary";
import { ar } from "date-fns/locale";



const ArticlesPage = () => {
    const { id } = useParams<{ id: string }>();
    const {translate} = useDictionary()
    const article = articles.find((article) => article.id === Number(id));
    if (!article) {
        return <div>Article not found</div>;
    }
    
  return (
    <ContentPage title={translate('articles')}>
<div className="content">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-12">
              <div className="blog-view">
                <h3 className="mb-3">
                  {translate(article.title)}
                </h3>
                <div className="blog blog-single-post">
                  <div className="blog-image">
                    <Link to="#">
                      <VImage
                        alt="article-image"
                        src={article.img}
                        className="img-fluid"
                      />
                    </Link>
                  </div>
                  <div className="blog-info d-md-flex align-items-center justify-content-between flex-wrap">
                    <div className="post-left">
                      <ul>
                        <li>
                          <span className="badge badge-dark fs-14 fw-medium">
                            {translate(article.mainTag)}
                          </span>
                        </li>
                        <li>
                          <i className="isax isax-calendar" />{new Date(article.createdOn).toLocaleString()}
                        </li>
                       
                      </ul>
                    </div>
                  
                  </div>
                  <div className="blog-content">
                    {
                        article.Paragraphs.map((paragraph, index) => (
                            <>
                            {paragraph.subTitle && <h4 className="mb-3">{translate(paragraph.subTitle)}</h4>}
                            <p key={index} className={paragraph.type === "bold" ? "content-block" : ""}>
                                {translate(paragraph.content)}
                            </p>
                            </>
                            
                        ))
                    }
                    
                  
                 
                  </div>
                </div>
               
                <h4 className="mb-3">{translate('tags')}</h4>
                <div className="d-flex align-items-center flex-wrap blog-tags gap-3 mb-4">
                    {
                        article.tags.map((tag, index) => (
                            <Link key={index} to="#" className="badge">
                                {translate(tag)}
                            </Link>
                        ))
                    }
                
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>

    </ContentPage>

    
  );
};

export default ArticlesPage;
